/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProvinciaDTO
 */
export interface ProvinciaDTO {
    /**
     * 
     * @type {string}
     * @memberof ProvinciaDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProvinciaDTO
     */
    descrizione?: string;
    /**
     * 
     * @type {string}
     * @memberof ProvinciaDTO
     */
    regioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProvinciaDTO
     */
    regione?: string;
    /**
     * 
     * @type {string}
     * @memberof ProvinciaDTO
     */
    nazioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProvinciaDTO
     */
    nazione?: string;
}

/**
 * Check if a given object implements the ProvinciaDTO interface.
 */
export function instanceOfProvinciaDTO(value: object): value is ProvinciaDTO {
    return true;
}

export function ProvinciaDTOFromJSON(json: any): ProvinciaDTO {
    return ProvinciaDTOFromJSONTyped(json, false);
}

export function ProvinciaDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProvinciaDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
        'regioneId': json['regioneId'] == null ? undefined : json['regioneId'],
        'regione': json['regione'] == null ? undefined : json['regione'],
        'nazioneId': json['nazioneId'] == null ? undefined : json['nazioneId'],
        'nazione': json['nazione'] == null ? undefined : json['nazione'],
    };
}

export function ProvinciaDTOToJSON(value?: ProvinciaDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'descrizione': value['descrizione'],
        'regioneId': value['regioneId'],
        'regione': value['regione'],
        'nazioneId': value['nazioneId'],
        'nazione': value['nazione'],
    };
}

